import { h, Component } from "preact";
import { useEffect, useState } from "preact/hooks";

import productApi from "../api/products";
import { sendError } from "../errors";

export default function loadingProductHoc(productId, View) {
  return (props) => {
    const [product, setProduct] = useState(null);

    useEffect(async () => {
      try {
        const data = await productApi.fetch(productId);
        setProduct(data.product);
      } catch (err) {
        sendError(err);
      }
    }, []);

    return <View {...props} product={product} />;
  };
}
